<div class="error-404">
    <h1>Not Found</h1>
    <img src="/assets/images/page-not-found/404-error.svg" alt="404 error" />
    <h2>Oops! Something went wrong</h2>
    <p>
        The page you are looking for doesn't exist, isn't available or was loaded incorrectly.<br />
        Please navigate back to an existing page or <a [routerLink]="contactUsRoute">contact us</a> if the error persists.
    </p>
</div>
